import './assets/Button.css';const r = "_bar_rzf6p_1", _ = "_root_rzf6p_6", o = "_fullWidth_rzf6p_71", t = "_primary_rzf6p_74", a = "_transparent_rzf6p_106", n = "_small_rzf6p_111", s = "_large_rzf6p_116", l = "_icon_rzf6p_121", p = "_decorator_rzf6p_133", c = {
  bar: r,
  root: _,
  fullWidth: o,
  primary: t,
  "default-blurred": "_default-blurred_rzf6p_90",
  transparent: a,
  small: n,
  large: s,
  icon: l,
  "straight-borders": "_straight-borders_rzf6p_125",
  "icon-node": "_icon-node_rzf6p_128",
  decorator: p
};
export {
  c as s
};
